/* eslint-disable no-useless-computed-key */
import DownloadIcon from '@mui/icons-material/Download';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../../../components/layout/Card';
import { Flex, Grid, MarginHandler } from '../../../styledComponents';
import ButtonCom from '../../../components/button/ButtonCom';
import TransitionsModal from '../../../components/modal/Modal';
import InputControl from '../../../components/input/InputControl';
import {  Tooltip, Box,Icon, Typography, Button, InputLabel, ListItemSecondaryAction, LinearProgress } from '@mui/material';
import { colors, fonts } from '../../../utils';
import FilledSelectOption from '../../../components/input/FilledSelectOption';
import { endPoints } from '../../../api/apiEndpoints';
import { Api } from '../../../api/api';
// import { setAllPostCategories } from '../../../redux/slices/posts/posts';
import { errorNotify, successNotify } from '../../../utils/helper';
import Table from '../../../components/table/Table';
import EditIcon from '@mui/icons-material/Edit';
import ImageIcon from '@mui/icons-material/Image';
import DeleteIcon from '@mui/icons-material/Delete';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { useNavigate } from 'react-router-dom';
import DeleteModal from '../../../components/deletemodal/DeleteModal';
import moment from 'moment';
import { setAllPermissions } from '../../../redux/slices/permissions/permissions';
import PermissionsDialog from './PermissionsDialog';

const styles = {
	box: {
		border: "1px solid lightgrey",
		padding: "3rem",
		width: "100%",
		marginTop: "2em",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center"
	},
	slide: {
		width: "200px",
		height: "200px",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		margin: "2em",
		border: "1px solid lightgrey",
		padding: "10px"

	},
	img: {
		width: "100%",
		margin: "auto"
	},
	slider: {
		display: "flex",
		alignItems: "center",

	}

};

const Permissions = () => {
	const dispatch = useDispatch();
	const { clientId, userId, fullName } = useSelector((state) => state?.activeAccount);
	const { primaryFont } = fonts;

	const { colorWhite, colorPrimary, } = colors;

	const { permissions } = useSelector((state) => state?.permissions);
	const [selectedFiles, setSelectedFiles] = useState([]);
	const [openModal, setOpenModal] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [isEditing, setIsEditing] = useState(false);
	const [modalName, setModalName] = useState("");
	const fileInputRef = useRef(null);
	const navigate = useNavigate();
	const [formData, setFormData] = useState({
		question: '',
		answer: '',
		type: '',
	});
	const [currentParams, setCurrentParams] = useState({
		limit: 10,
		page: 1,
		totalPages: 0,
		totalRecords: 0,
	});
	const [userRules, setUserRules] = useState([]);
	const [dialogData, setDialogData] = useState({
		enabled: '',
		id: '',
		description: '',
		title: '',
		method: '',
		rule_set: [],
		consumer: ''
	});
	// const [currentRules, setCurrenconsumertRules] = useState(dialogData?.rule_set);



	const handleCloseModal = () => {
		setOpenModal(false);
		setIsEditing(false)
	};

	const handleChange = (e) => {
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	const getPermissions = async (limit, page) => {
		setIsLoading(true)
		try {

			await Api.post(endPoints?.permissions?.get, {
				"limit": limit || 10,
				"page": page || 1,
				"columns": "*",
				"sortby": "ASC",
				"orderby": "id",
				"where": "displayed = $1",
				"values": true
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					dispatch(
						setAllPermissions(
							response?.data?.data?.list?.data?.map((d, index) => ({
								index: index + 1,
								id: d?.id,
								title: d?.title,
								description: d?.description,
								dt: d?.dt,
								enabled: d?.enabled,
								displayed: d?.displayed,
								rule_set: d?.rule_set,
								consumer: d?.consumer,
								method: d?.method,
							})
							),
						),
					);
					const { page, limit, totalPages, totalRecords } = response?.data?.data?.list?.pagination;
					setCurrentParams({ page, limit, totalPages, totalRecords });
					setIsLoading(false)
				})
				.catch((error) => {
					
					// if (error?.response?.status === 400) {
					// 	errorNotify(error?.response?.data);
					// 	setDisabledBtn(false);
					// }
					// setErrMsg(error?.response?.data?.message || errorMsg);
				});
		} catch (err) {
			// setErrMsg('Login Failed');
			// setDisabledBtn(false);
		}
	};
	const getrulesSet = async () => {
		try {

			await Api.get(endPoints?.rulesSet?.get, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {

					setUserRules(response?.data?.data?.rule_set)
					// dispatch(
					// 	setAllPermissions(
					// 		response?.data?.data?.rule_set?.data?.map((d, index) => ({
					// 			index: index + 1,
					// 			id: d?.id,
					// 			title: d?.title,
					// 			description: d?.description,
					// 			dt: d?.dt,
					// 			enabled: d?.enabled,
					// 			displayed: d?.displayed,
					// 			rule_set: d?.rule_set,
					// 			consumer: d?.consumer,
					// 			method: d?.method,
					// 		})
					// 		),
					// 	),
					// );
				})
				.catch((error) => {
					// if (error?.response?.status === 400) {
					// 	errorNotify(error?.response?.data);
					// 	setDisabledBtn(false);
					// }
					// setErrMsg(error?.response?.data?.message || errorMsg);
				});
		} catch (err) {
			// setErrMsg('Login Failed');
			// setDisabledBtn(false);
		}
	};


	const handleDeletePermission = async () => {

		try {

			await Api.post(endPoints?.faqs?.delete, {
				...formData
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					successNotify("Faq Deleted Successfully")
					handleCloseDeleteModal();
					getPermissions();

				})
				.catch((error) => {

				});

		} catch (err) {
		}
	};
	const handleCreateModal = () => {
		setDialogData({
			enabled: '',
			id: '',
			description: '',
			title: '',
			method: '',
			rule_set: [],
			consumer: ''
		})
		setOpenModal(true)
		setIsEditing(false);

	};
	const handleEditModal = (val) => {
		// setIsEditing(true);
		// setFormData({ question: val.question, answer: val.answer, type: val.type, creator_id: val.creator_id, id: val.id })
		// setOpenModal(true)
	};


	const handleOpenDeleteModal = (val) => {
		// setFormData({ id: val.id })
		// setOpenDeleteModal(true)
	};
	const handleCloseDeleteModal = () => {
		// setFormData({ question: '', answer: '', type: '' })
		// setOpenDeleteModal(false)
	};



	useEffect(() => {
		getPermissions();
		getrulesSet();
	}, [])


	const column = [
		{
			title: 'Id',
			field: 'id',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.id}</h4>,
		},
		// {
		// 	title: 'Category Id',
		// 	field: 'category_id',
		// 	render: (rowData) => <h4 className='font-face-B'>{rowData?.category_id}</h4>,
		// },
		{
			title: 'Title',
			field: 'title',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.title}</h4>,
		},

		{
			title: 'Consumer',
			field: 'consumer',
			render: (rowData) => <h4 className='font-face-R'>{rowData.method !== 'APP' ? `${rowData.method}END` : rowData.method}</h4>,
		},
		{
			title: 'Enabled',
			field: 'enabled',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.enabled ? <Icon color='success' className="text-green text-16">check_circle</Icon> : <Icon className="text-red text-16">cancel</Icon>}</h4>,
		},
		// {
		// 	title: 'Date',
		// 	field: 'dt',
		// 	render: (rowData) => <h4 className='font-face-R'>{moment(rowData?.dt).format('DD-MM-YYYY')}</h4>,
		// },
		// {
		// 	title: 'Edit',
		// 	field: 'edit',
		// 	filtering: false,
		// 	render: (rowData) => (
		// 		<Tooltip title='Edit'>
		// 			<IconButton onClick={() => handleEditModal(rowData)} aria-label='Edit'>
		// 				<EditIcon />
		// 			</IconButton>
		// 		</Tooltip>
		// 	),
		// },
		// {
		// 	title: 'Delete',
		// 	field: 'delete',
		// 	filtering: false,
		// 	render: (rowData) => (
		// 		<Tooltip title='Delete'>
		// 			<IconButton onClick={() => handleOpenDeleteModal(rowData)} aria-label='Delete'>
		// 				<DeleteIcon />
		// 			</IconButton>
		// 		</Tooltip>
		// 	),
		// },

	];

	function handleClick(n) {
		setDialogData({
			enabled: n.enabled,
			id: n.id,
			description: n.description,
			title: n.title,
			method: n.method,
			rule_set: n.rule_set,
			consumer: n.consumer,
			displayRules:
				n.method === 'FRONT'
					? userRules.frontend
					: n.method === 'APP'
						? userRules.app
						: n.method === 'BACK'
							? userRules.backend
							: []
		});
		setOpenModal(true);
		setIsEditing(true);
	}


	return (
		<>

			<Card margin='3rem 1.5rem' padding='3rem'>

				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>
					<ButtonCom onClickHandler={handleCreateModal} btnTitle={"Create"} />
				</Flex>




				<PermissionsDialog

					isOpen={openModal}
					handleCloseModal={handleCloseModal}
					type="Update"
					data={dialogData}
					setDialogData={setDialogData}
					isEditing={isEditing}
					userRules={userRules}
					getPermissions={getPermissions}
				/>




				{/* <DeleteModal
					open={openDeleteModal}
					handleClose={handleCloseDeleteModal}
					handleDelete={handleDeletePermission}
				/> */}



				{isLoading ?
					<Box sx={{ m: '5rem' }}>
						<LinearProgress color="success" />
					</Box>
					:
					<Table
						columns={column}
						tableData={permissions?.map((item) => ({ ...item }))}
						sorting
						columnsButton
						padding="3rem"
						showTitle
						paginationType='normal'
						titleHeading="Permissions"
						showToolbar={true}
						onClickRow={(n) => handleClick(n)}
						pageSize={currentParams.limit}
						onChangeRowsPerPage={(event) => getPermissions(parseInt(event.target.value, 10), 1)}
						totalRecords={currentParams.totalRecords}
						handlePageChange={(event, newPage) => getPermissions(currentParams.limit, newPage + 1)}
						curPage={currentParams.page -1}

					/>
				}








			</Card>
		</>
	);
};

export default Permissions;
